'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.day;


// WEBPACK FOOTER //
// ./~/sugar-date/number/day.js